module.exports = __webpack_public_path__ + "static/media/Logo-SpartaGroup-2019.a4224336.png";